import React, { useEffect, useState } from 'react';
import GridItem from 'components/Grid/GridItem';
import InfoCard from 'components/Info/InfoCard';
import { ECommerceService } from 'services/eCommerce/eCommerce';
import { finalize } from 'rxjs/operators';
import { translate } from 'components/Translation';
import { EventCodes } from 'views/Activities/commons/constants';

interface IEventDetailsProps {
	eventCode: string | undefined;
	amount: string | null | undefined;
	src: string | null | undefined;
	target: string | null | undefined;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}
const EventDetailsCard = ({ eventCode, amount, src, target, setLoading }: IEventDetailsProps) => {
	const [elements, setElements] = useState<any[]>([]);
	const [targetCounter, setTargetCounter] = useState<number | undefined>();

	useEffect(() => {
		setElements([]);
		if (eventCode === EventCodes.creditLimitChange || eventCode === EventCodes.creditLimitChangeFail) {
			setElements([
				{
					title: translate('activities.details.newLimit'),
					value: amount ? translate('price', amount) : '',
				},
				{
					title: translate('activities.details.oldLimit'),
					value: src ? translate('price', src) : '',
				},
			]);
			setLoading(false);
		} else if (
			[
				EventCodes.spoProductChange,
				EventCodes.spoProductActivate,
				EventCodes.spoProductActivateFail,
				EventCodes.spoProductDeactivate,
			].indexOf(eventCode as EventCodes) >= 0 &&
			target
		) {
			const targets = target.split(',');
			if (targets.length > 0) {
				setTargetCounter(targets.length);
			}
			targets.forEach((targetId) => {
				ECommerceService.getContentByPartNumber(`OM_${targetId}`)
					.pipe(
						finalize(() => {
							setTargetCounter((prevState) => (prevState ? prevState - 1 : 0));
						})
					)
					.subscribe(({ response }) => {
						if (response.catalogEntryView) {
							setElements((e) => [
								...e,
								{
									title: translate('activities.details.product'),
									value: response.catalogEntryView[0].name,
								},
							]);
						}
					});
			});
		} else {
			setLoading(false);
		}
	}, [eventCode, amount, target, src, setLoading]);

	useEffect(() => {
		if (targetCounter === 0) {
			setLoading(false);
			setTargetCounter(undefined);
		}
	}, [targetCounter, setLoading]);

	return (
		<GridItem xs={12} md={6}>
			<div>
				{!!elements.length && (
					<InfoCard elements={elements} title={translate('activities.details.event.details')} />
				)}
			</div>
		</GridItem>
	);
};

export default EventDetailsCard;
